/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Review_TitleInputs */

const en_us2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your answers`)
};

const pt_br2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise suas respostas`)
};

const es_419_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tus respuestas`)
};

const pt_pt2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revê as tuas respostas`)
};

const fr_fr2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie tes réponses`)
};

const de_de2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten prüfen`)
};

const it_it2_intake_review_title = /** @type {(inputs: Intake_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi le tue risposte`)
};

/**
* | output |
* | --- |
* | "Review your answers" |
*
* @param {Intake_Review_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_review_title = /** @type {((inputs?: Intake_Review_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Review_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_review_title(inputs)
	if (locale === "es-419") return es_419_intake_review_title(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_review_title(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_review_title(inputs)
	if (locale === "de-DE") return de_de2_intake_review_title(inputs)
	if (locale === "it-IT") return it_it2_intake_review_title(inputs)
	return en_us2_intake_review_title(inputs)
});
export { intake_review_title as "intake.review_title" }